import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, FormProvider } from 'react-hook-form';
import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import { useLayoutContext } from 'contexts/LayoutContext';
import GeneralInformation from './GeneralInformation';
import { Button } from '@mui/material';
import { vehicle as rules } from 'further-ui/validations';
import FullHeightView from 'components/new/FullHeightView';
import { Row } from 'further-ui/components/Layout';

const FundSetup: React.FC = () => {
  const mutationOpts = useHandleTrpcMutation();
  const { selectedVehicleId } = useLayoutContext();

  const [vehicleData] = api.vehicle.getById.useSuspenseQuery({
    vehicleId: selectedVehicleId ?? '',
  });

  const updateVehicle = api.vehicle.update.useMutation(
    mutationOpts({
      successMessage: 'Vehicle updated successfully.',
    }),
  );

  const formMethods = useForm({
    shouldFocusError: true,
    resolver: zodResolver(rules.Update),
    values: vehicleData,
    criteriaMode: 'all',
  });

  const onSubmit = async (data) => {
    updateVehicle.mutate({ ...data, vehicleId: selectedVehicleId ?? '' });
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <FullHeightView
          actionBar={
            <Row fullWidth justify="flex-end">
              <Button
                variant="contained"
                size="large"
                color="primary"
                type="submit"
                loading={updateVehicle.isPending}
              >
                Save
              </Button>
            </Row>
          }
        >
          <GeneralInformation
            disableChangeOfCurrency={(vehicleData.transactionsCount ?? 0) > 0}
            disableChangeOfFinancialYear={vehicleData.hasApprovedFees ?? false}
            disableCommitmentTypeChange={!!vehicleData.firstCloseDate}
            commitmentOptions={vehicleData.commitmentOptions}
          />
        </FullHeightView>
      </form>
    </FormProvider>
  );
};

export default FundSetup;
